import classNames from "classnames";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import "./style.scss";

interface Props {
  pageRangeDisplayed?: number;
  pageCount?: number;
  marginPagesDisplayed?: number;
  onChange?(selected: number): void;
  className?: string;
  value?: number;
}
export const Pagination = ({
  value = 0,
  pageRangeDisplayed = 2,
  pageCount = 10,
  marginPagesDisplayed = 1,
  onChange = () => {},
  className,
}: Props) => {
  return pageCount ? (
    <ReactPaginate
      pageRangeDisplayed={pageRangeDisplayed}
      pageCount={Math.ceil(pageCount)}
      marginPagesDisplayed={marginPagesDisplayed}
      pageClassName="pagination-control__page"
      activeClassName="pagination-control__active"
      previousClassName="pagination-control__arrow"
      nextClassName="pagination-control__arrow"
      disabledClassName="pagination-control__page"
      breakClassName="pagination-control__page"
      containerClassName={classNames(
        "pagination-control__container",
        className,
      )}
      previousLabel={<FaAngleLeft />}
      nextLabel={<FaAngleRight />}
      forcePage={Math.ceil(value)}
      onPageChange={({ selected }) => onChange(selected)}
    />
  ) : null;
};
